import React, { useState } from "react";
import { MgsShippingChargeModal } from "@atoms/MgsShippingChargeModal";
import { IProps } from "@atoms/MgsShippingChargeTooltip/types";
import InfoIcon from "@src/componentsNew/Icons/Icons/InfoIcon";

const MgsShippingChargeTooltip: React.FC<IProps> = ({

}: IProps) => {

  const [showMgsShippingChargeTooltip, setShowMgsShippingChargeTooltip] = useState(false);
  const handleMgsShippingChargeTooltipShow = () => {
    setShowMgsShippingChargeTooltip(true);
  }

  const handleMgsShippingChargeTooltipClose = () => {
    setShowMgsShippingChargeTooltip(false);
  }

  return (
    <span style={{ marginRight: "2rem" }}>
      <InfoIcon onClick={handleMgsShippingChargeTooltipShow} />
      <MgsShippingChargeModal show={showMgsShippingChargeTooltip} onHide={handleMgsShippingChargeTooltipClose} />
    </span>
  );
}

export { MgsShippingChargeTooltip }
